import { render, staticRenderFns } from "./NewBasketDialog.vue?vue&type=template&id=1d303116"
import script from "./NewBasketDialog.vue?vue&type=script&lang=js"
export * from "./NewBasketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports